import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maintainTeamMemberCellValue'
})
export class MaintainTeamMemberCellValuePipe implements PipeTransform {

  transform(column: string, index: number, studentCollectionTeamMemberPermission = []): any {
    const value = studentCollectionTeamMemberPermission[index][column];
    return value;
  }
}